var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cmg-tooltip-container"},[_c('div',{staticClass:"cmg-tooltip"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }